module.exports = __webpack_public_path__ + "img/imageOne.f85329cf.png";